import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import "dayjs/locale/es";

dayjs.extend(customParseFormat);

export const formatCreateP10 = (data) => {
    if (!data) {
        return [[

            { component: 'text', left: 69.1111, top: 15.2778, textAnchor: "left", scale: 1 },
            { component: 'text', left: 69.1111, top: 25.6111, textAnchor: "left", scale: 1 },

            { component: 'text', left: 5, top: 50, textAnchor: "left", scale: 1 },
            { component: 'text', left: 5, top: 66, textAnchor: "left", scale: 1 },
            { component: 'text', left: 5, top: 79, textAnchor: "left", scale: 1 },
            { component: 'text', left: 5, top: 92, textAnchor: "left", scale: 1 },


            { component: 'P10red', height: 160 * 4, width: 320 * 4, left: 32, top: 50-(((160*4+400)/2)*100/3600)+1 },
            { component: 'P10red', height: 160 * 2, width: 320 * 3, left: 39, top: 66-(((160*2+400)/2)*100/3600)+1.6 },
            { component: 'P10red', height: 160 * 2, width: 320 * 3, left: 39, top: 79-(((160*2+400)/2)*100/3600)+1.6 },

            { component: 'P10red', height: 160 * 4, width: 320 * 4, left: 67, top: 50-(((160*4+400)/2)*100/3600)+1 },
            { component: 'P10red', height: 160 * 2, width: 320 * 3, left: 67, top: 66-(((160*2+400)/2)*100/3600)+1.6 },
            { component: 'P10red', height: 160 * 2, width: 320 * 3, left: 67, top: 79-(((160*2+400)/2)*100/3600)+1.6 },

            { component: 'P10red', height: 160 * 2, width: 320 * 7, left: 39, top: 92-(((160*2+400)/2)*100/3600)+1.6 },

        ], { state: false }];
    }
    return [[
        { component: 'text', fontWeight: 700, fontSize: 400, left: 69.1111, top: 15.2778, textAnchor: "middle", scale: .9, color: '#fff', text: 'NOTIFICACIÓN DE' },
        { component: 'text', fontWeight: 700, fontSize: 400, left: 69.1111, top: 25.6111, textAnchor: "middle", scale: .9, color: '#fff', text: 'VOLADURA' },

        { component: 'text', fontWeight: 700, fontSize: 400, left: 5, top: 50, textAnchor: "left", scale: .85, color: '#fff', text: 'TAJO' },
        { component: 'text', fontWeight: 700, fontSize: 400, left: 34, top: 50-1, textAnchor: "left", scale: .85, color: '#fff', text: ':' },
        { component: 'text', fontWeight: 700, fontSize: 400, left: 5, top: 66 , textAnchor: "left", scale: .85, color: '#fff', text: 'NIVEL' },
        { component: 'text', fontWeight: 700, fontSize: 400, left: 34, top: 66-1, textAnchor: "left", scale: .85, color: '#fff', text: ':' },
        { component: 'text', fontWeight: 700, fontSize: 400, left: 5, top: 79 , textAnchor: "left", scale: .85, color: '#fff', text: 'HORA' },
        { component: 'text', fontWeight: 700, fontSize: 400, left: 34, top: 79-1, textAnchor: "left", scale: .85, color: '#fff', text: ':' },

        { component: 'text', fontWeight: 700, fontSize: 400, left: 5, top: 92, textAnchor: "left", scale: .85, color: '#fff', text: 'FECHA' },
        { component: 'text', fontWeight: 700, fontSize: 400, left: 34, top: 92-1, textAnchor: "left", scale: .85, color: '#fff', text: ':' },

        { component: 'P10red', height: 160 * 2, width: 320 * 4, fontWeight: 900, fontSize: 400, left: 32, top: 50-(((160*4+400)/2)*100/3600)+1, scale: 0.78, color: '#f00', text: data.disparo1Tajo?.split(' ')[0]?.trim() ?? data['TAJO 1']?.split(' ')[0]?.trim() ?? ' ' },
        { component: 'P10red', height: 160 * 2, width: 320 * 4, fontWeight: 900, fontSize: 400, left: 32, top: 50-(((160*2+400)/2)*100/3600)+5.348, scale: 0.78, color: '#f00', text: data.disparo1Tajo?.split(' ')[1]?.trim() ?? data['TAJO 1']?.split(' ')[1]?.trim() ?? ' ' },
        { component: 'P10red', height: 160 * 2, width: 320 * 3, fontWeight: 900, fontSize: 400, left: 39, top: 66-(((160*2+400)/2)*100/3600)+1.6, scale: .78, color: '#f00', text: data.disparo1Nivel ?? data['NIVEL 1'] ?? ' ' },
        { component: 'P10red', height: 160 * 2, width: 320 * 3, fontWeight: 900, fontSize: 400, left: 39, top: 79-(((160*2+400)/2)*100/3600)+1.6, scale: .78, color: '#f00', text: data.disparo1Hora ?? data['HORA 1'] ?? ' ' },

        { component: 'P10red', height: 160 * 2, width: 320 * 4, fontWeight: 900, fontSize: 400, left: 67, top: 50-(((160*4+400)/2)*100/3600)+1, scale: 0.78, color: '#f00', text: data.disparo2Tajo?.split(' ')[0]?.trim() ?? data['TAJO 2']?.split(' ')[0]?.trim() ?? ' ' },
        { component: 'P10red', height: 160 * 2, width: 320 * 4, fontWeight: 900, fontSize: 400, left: 67, top: 50-(((160*2+400)/2)*100/3600)+5.348, scale: 0.78, color: '#f00', text: data.disparo2Tajo?.split(' ')[1]?.trim() ?? data['TAJO 2']?.split(' ')[1]?.trim() ?? ' ' },
        { component: 'P10red', height: 160 * 2, width: 320 * 3, fontWeight: 900, fontSize: 400, left: 67, top: 66-(((160*2+400)/2)*100/3600)+1.6, scale: 0.78, color: '#f00', text: data.disparo2Nivel ?? data['NIVEL 2'] ?? ' ' },
        { component: 'P10red', height: 160 * 2, width: 320 * 3, fontWeight: 900, fontSize: 400, left: 67, top: 79-(((160*2+400)/2)*100/3600)+1.6, scale: 0.78, color: '#f00', text: data.disparo2Hora ?? data['HORA 2'] ?? ' '  },

        { component: 'P10red', height: 160 * 2, width: 320 * 7, fontWeight: 900, fontSize: 400, left: 39, top: 92-(((160*2+400)/2)*100/3600)+1.6, scale: 0.78, color: '#f00', text: (() => {
            const fecha = data.fecha || data.FECHA || '';

            if (dayjs(fecha, "YYYY-MM-DD", true).isValid()) {
                return dayjs(fecha, "YYYY-MM-DD")
                    .locale("es")
                    .format("DD-MMM-YYYY")
                    .toUpperCase();
            }

            if (dayjs(fecha, "DD-MM-YYYY", true).isValid()) {
                return dayjs(fecha, "DD-MM-YYYY")
                    .locale("es")
                    .format("DD-MMM-YYYY")
                    .toUpperCase();
            }

            return '';
        })(), },


    ], { state: true }];
}